import React from 'react';
import PropTypes from 'prop-types';
import PriceDisplay from '../PriceDisplay/PriceDisplay';
import StarRating from '../StarRating/StarRating';
import ProductBadge from '../ProductBadge/ProductBadge';
import Link from '../Link/Link';
import normalizeAttributeGroups from '../../helpers/normalizeAttributeGroups';


const ProductTile = function ProductTileComponent({ product, track }) {
  const attributes = normalizeAttributeGroups(product);

  return (
    <Link
      className="product-tile"
      href={product.productUrl}
      action={() => track.analytics.productClick(track.measure, track.list, { stopRedirect: true })}
    >
      <div className="product-tile__body">
        <div className="product-tile__image-wrapper">
          <ProductBadge className="product-tile__badge" attributes={attributes} promotions={product.promotions} />
          <img
            className="product-tile__image"
            src={product.images.productTile[0].url}
            alt=""
          />
        </div>
        <div className="product-tile__description-wrapper">
          <div className="product-tile__title">{product.productName}</div>
          <div className="product-card__rating"><StarRating {...product.ratingSummary} /></div>
          <PriceDisplay {...product} />
        </div>
      </div>
    </Link>
  );
};

ProductTile.propTypes = {
  product: PropTypes.shape({}).isRequired,
  track: PropTypes.shape({}).isRequired,
};

export default ProductTile;
